import { render } from "./OrderFactory.vue?vue&type=template&id=3c961ea3&scoped=true"
import script from "./OrderFactory.vue?vue&type=script&lang=js"
export * from "./OrderFactory.vue?vue&type=script&lang=js"

import "./OrderFactory.vue?vue&type=style&index=0&id=3c961ea3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c961ea3"

export default script